/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Anchor = [
  ["path", { d: "M12 6v16" }],
  ["path", { d: "m19 13 2-1a9 9 0 0 1-18 0l2 1" }],
  ["path", { d: "M9 11h6" }],
  ["circle", { cx: "12", cy: "4", r: "2" }]
];

export { Anchor as default };
//# sourceMappingURL=anchor.js.map
